export enum DatasetType {
    Training = "Training",
    Metrics = "Metrics"
}

export enum DatasetSchemaItemStateType {
    NumberMin = "NumberMin",
    NumberMax = "NumberMax",
    NumberAvg = "NumberAvg",
    Number99Min = "Number99Min",
    Number99Max = "Number99Max",
    Number99Avg = "Number99Avg",
    Number95Min = "Number95Min",
    Number95Max = "Number95Max",
    Number95Avg = "Number95Avg",
    Number90Min = "Number90Min",
    Number90Max = "Number90Max",
    Number90Avg = "Number90Avg",
    NumberArrayMin = "NumberArrayMin",
    NumberArrayMax = "NumberArrayMax",
    NumberArrayAvg = "NumberArrayAvg",
    NumberArray99Min = "NumberArray99Min",
    NumberArray99Max = "NumberArray99Max",
    NumberArray99Avg = "NumberArray99Avg",
    NumberArray95Min = "NumberArray95Min",
    NumberArray95Max = "NumberArray95Max",
    NumberArray95Avg = "NumberArray95Avg",
    NumberArray90Min = "NumberArray90Min",
    NumberArray90Max = "NumberArray90Max",
    NumberArray90Avg = "NumberArray90Avg",
    CategoryBalance = "CategoryBalance",
    CategoryBalancePercentage = "CategoryBalancePercentage",
    StringLengthMin = "StringLengthMin",
    StringLengthMax = "StringLengthMax",
    StringLengthAvg = "StringLengthAvg"
}

export type CategoryDistribution = Record<string, number>;

export type NumberArrayDistribution = (number | null)[];

export type DatasetReportValue = number | NumberArrayDistribution | CategoryDistribution;

export type DatasetReportItem = {
    type: DatasetSchemaItemStateType,
    datasetType: DatasetType,
    value: DatasetReportValue
}

export type DatasetReport = {
    lastUpdated?: string,
    schemaItemReport: Record<string, DatasetReportItem[]>
}

export const isNumberArrayDistribution = (value: DatasetReportValue | undefined): value is NumberArrayDistribution =>
    Array.isArray(value);

export const isCategoryDistribution = (value: DatasetReportValue | undefined): value is CategoryDistribution =>
    typeof value === "object" && value !== null && !Array.isArray(value);
